import { render, staticRenderFns } from "./CommonHome.vue?vue&type=template&id=37295d28&scoped=true&"
import script from "./CommonHome.vue?vue&type=script&lang=js&"
export * from "./CommonHome.vue?vue&type=script&lang=js&"
import style0 from "./CommonHome.vue?vue&type=style&index=0&id=37295d28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37295d28",
  null
  
)

export default component.exports